import { defineComponent as _defineComponent } from 'vue'
import sparkles from '../../assets/images/sparkle.svg';

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateTemplateButton',
  props: {
    disabled: { type: Boolean }
  },
  emits: ['createTemplate', 'importTemplateFromCustomilyDesign'],
  setup(__props: any, { emit }) {




const createTemplate = function () {
    emit('createTemplate');
};

const importTemplateFromCustomilyDesign = function () {
    emit('importTemplateFromCustomilyDesign');
};

return { __sfc: true,emit, createTemplate, importTemplateFromCustomilyDesign, sparkles }
}

})